import { useAlternatingMessage } from '~/hooks/useAlternatingMessage/useAlternatingMessage';

import { ProgressIndicator } from './ProgressIndicator';

export interface ProgressIndicatorAlternatingProps {
  messages: string[];
  interval?: number;
  progressBarWidth?: string;
}

const defaultInterval = 5000;
const defaultProgressBarWidth = '10%';

export const ProgressIndicatorAlternating = ({
  messages,
  interval,
  progressBarWidth,
}: ProgressIndicatorAlternatingProps) => {
  const message = useAlternatingMessage(messages, {
    interval: interval ?? defaultInterval,
  });

  return <ProgressIndicator message={message} progressBarWidth={progressBarWidth ?? defaultProgressBarWidth} />;
};
